
import * as firebase from 'firebase/app';

import 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyBra9Gw1Rx-YurFzf673DW-61MCU1BmjH4',
  authDomain: 'ahapte-vet.firebaseapp.com',
  databaseURL: 'https://ahapte-vet.firebaseio.com',
  projectId: 'ahapte-vet',
  storageBucket: 'gs://ahapte-vet.appspot.com/',
  messagingSenderId: '811814596961',
  appId: '1:811814596961:web:06f9de09078f436d915520',
  measurementId: 'G-VV62JNR0BW',
};

// Initialize Firebase
export function onAuthStateChanged() {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        resolve(user);
      } else {
        reject(new Error('User is not authenticated'));
      }
    });
  });
}

// Initialize Firebase

firebase.initializeApp(firebaseConfig);

export default firebase;
